import React from "react";
import { RouterProvider } from "react-router";

import FullLoadingScreen from "../FullLoadingScreen";

import { useAuth } from "../../features/auth/AuthContext";

import { router } from "../../utils/router";

const RoleBasedRouterProvider = () => {
	const { loggedIn } = useAuth();

	if (loggedIn === null) {
		return <FullLoadingScreen />;
	}

	if (loggedIn === false) {
		return <RouterProvider router={router} />;
	}

	return <RouterProvider router={router} />;
};

export default RoleBasedRouterProvider;
